"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTheme = exports.useAddThemeEventListener = exports.themes = exports.setTheme = exports.initThemes = exports.getTheme = exports.autoSwitchThemes = exports.addThemeEventListener = exports.addSysThemeChangeListener = exports.ThemeHOC = exports.ThemeAutoSwitchHOC = void 0;
var _ahooks = require("ahooks");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _jsStorage = _interopRequireDefault(require("js-storage"));
var _react = _interopRequireWildcard(require("react"));
var _getSubdomain = _interopRequireDefault(require("../_util/getSubdomain"));
var _index = _interopRequireDefault(require("../style/variables/index.json"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let themes = exports.themes = ['dark', 'light'];
const _event = 'THEME_SWITCH_EVENT';
const _eventKey = 'theme';
const Storage = _jsStorage.default.localStorage;
function customUserEvent(value) {
  var event = new Event(_event);
  event.key = _eventKey;
  event.newValue = value;
  window.dispatchEvent(event);
  _jsCookie.default.set(_eventKey, value, {
    // domain: '.' + window.location.hostname.split('.').slice(-3).join('.'),
    domain: (0, _getSubdomain.default)(),
    expires: 365
  });
  Storage.set(_eventKey, value);
}
const initThemes = opts => {
  exports.themes = themes = opts.themes;
};
exports.initThemes = initThemes;
const getTheme = () => {
  // get user local
  const theme = _jsCookie.default.get(_eventKey);
  if (theme) {
    return theme;
  }

  // get system themes
  const canSwitchThemes = themes.indexOf('dark') !== -1 && themes.indexOf('light') !== -1;
  if (canSwitchThemes && !!window.matchMedia('(prefers-color-scheme: dark)')) {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (isDarkMode) {
      return 'dark';
    } else {
      return 'light';
    }
  }

  // fallback
  return themes[0];
};
exports.getTheme = getTheme;
const autoSwitchThemes = exports.autoSwitchThemes = {
  setEnable: () => {
    Storage.set('disableAutoSwitchThemes', false);
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  },
  setDisable: () => {
    Storage.set('disableAutoSwitchThemes', true);
  },
  getIsDisable: () => {
    return Storage.get('disableAutoSwitchThemes');
  }
};
const addSysThemeChangeListener = () => {
  var _window;
  // only dark and light exist at same time
  const canSwitchThemes = themes.indexOf('dark') !== -1 && themes.indexOf('light') !== -1;
  if (!canSwitchThemes || autoSwitchThemes.getIsDisable()) {
    return;
  }

  // listen when user switch
  const darkModeMediaQuery = (_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia('(prefers-color-scheme: dark)');
  darkModeMediaQuery.addEventListener('change', e => {
    if (autoSwitchThemes.getIsDisable()) {
      return;
    }
    if (e.matches) {
      setTheme('dark');
    } else {
      setTheme('light');
    }
  });
};
exports.addSysThemeChangeListener = addSysThemeChangeListener;
const setTheme = theme => {
  customUserEvent(theme);
};
exports.setTheme = setTheme;
const addThemeEventListener = eventFn => {
  function _eventFn(e) {
    window.setTimeout(() => {
      eventFn(e.newValue, e);
    });
  }
  function storageFn(e) {
    window.setTimeout(() => {
      e.key === _eventKey && eventFn(e.newValue, e);
    });
  }
  //当前tab页有效
  window.addEventListener(_event, _eventFn);
  //非当前tab页有效
  window.addEventListener('storage', storageFn);
  return () => {
    window.removeEventListener(_event, _eventFn);
    window.removeEventListener('storage', storageFn);
  };
};
exports.addThemeEventListener = addThemeEventListener;
const useAddThemeEventListener = () => {
  const [theme, setTheme] = (0, _react.useState)(getTheme());
  const latestThemeRef = (0, _ahooks.useLatest)(theme);
  (0, _react.useEffect)(() => {
    const removeEventListener = addThemeEventListener((newTheme, e) => {
      if (newTheme !== latestThemeRef.current) {
        setTheme(newTheme);
      }
    });
    return () => {
      removeEventListener();
    };
  }, []);
  return theme;
};
exports.useAddThemeEventListener = useAddThemeEventListener;
const ThemeAutoSwitchHOC = props => {
  const {
    dark,
    light,
    ...restProps
  } = props;
  const theme = useAddThemeEventListener();
  const dom = (0, _react.useMemo)(() => {
    if (theme === 'telin' || theme === 'chief' || theme === 'harmony') {
      return light;
    } else {
      return props[theme];
    }
  }, [theme, props]);
  return /*#__PURE__*/_react.default.cloneElement(dom, {
    ...restProps,
    ...(dom === null || dom === void 0 ? void 0 : dom.props)
  });
};
exports.ThemeAutoSwitchHOC = ThemeAutoSwitchHOC;
const useTheme = opts => {
  const {
    prefixClass = 'zen-design' //TODO 写provider时统一改掉
  } = opts || {};
  const theme = useAddThemeEventListener();
  const [colors, setColors] = (0, _react.useState)({});
  const getColors = (0, _react.useCallback)(() => {
    const bodyStyle = getComputedStyle(document.body);
    const propertyStr = bodyStyle.getPropertyValue("--".concat(prefixClass, "-property"));
    if (!propertyStr) {
      return undefined;
    }
    const property = propertyStr === null || propertyStr === void 0 ? void 0 : propertyStr.split(',');
    let _colors = {};
    property === null || property === void 0 || property.forEach(key => {
      _colors = {
        ..._colors,
        [key]: bodyStyle.getPropertyValue(key)
      };
    });
    return _colors;
  }, []);
  (0, _react.useEffect)(() => {
    let Timer;
    const handleColor = () => {
      const bodyStyle = getComputedStyle(document.body);
      const varTheme = bodyStyle.getPropertyValue("--".concat(prefixClass, "-theme"));
      const _colors = getColors();
      if (_colors && varTheme === theme) {
        clearInterval(Timer);
        setColors(_colors);
      }
    };
    Timer = setInterval(handleColor, 300);
    handleColor();
    return () => clearInterval(Timer);
  }, [theme]);
  return [theme, colors, _index.default];
};
exports.useTheme = useTheme;
const ThemeHOC = props => {
  const {
    children,
    prefixClass = 'zen-design' //TODO 写provider时统一改掉
  } = props;
  const [theme, colors, lessVars] = useTheme({
    prefixClass
  });
  return /*#__PURE__*/_react.default.cloneElement(children, {
    ...children.props,
    theme,
    colors,
    lessVars
  });
};
exports.ThemeHOC = ThemeHOC;